module.exports = __webpack_public_path__ + "static/installation_mobile_background-fc385f3aae0438c713cb8c57bd62d919.png";